import React from 'react';
import { CLOSING_LINE, CLOSING_SUB_1, CLOSING_SUB_2 } from '../data/resinContent';
export function ClosingCtaSection() {
  return <section className="w-full bg-charcoal-950 py-12 sm:py-16" aria-labelledby="closing-title" data-id="element-47" data-mp="34w1x85j9szac">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-48" data-mp="3jky3bx1ro28b">
        <h2 id="closing-title" className="font-display text-[1.7rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.4rem]" data-id="element-49" data-mp="3elux49a1vpyr">
          {CLOSING_LINE}
        </h2>
        <p className="mt-5 font-display text-xl italic leading-snug text-ivory-200 sm:text-2xl" data-id="element-50" data-mp="2ly8xtd7uv7hp">{CLOSING_SUB_1}</p>
        <p className="font-display text-xl italic leading-snug text-champagne sm:text-2xl" data-id="element-51" data-mp="30w16blezivme">{CLOSING_SUB_2}</p>
      </div>
    </section>;
}